module.exports = __webpack_public_path__ + "static/media/light1.60e36020.png";